export default __webpack_public_path__ + "static/ameena-balthazaurus-scroll-7951852d238f33a65cf2caa7238d4ed8.mp4";